import { Dispatch, SetStateAction } from "react";

function reduceErrorMessage(errors, key) {
  return errors[key].reduce
    ? errors[key].reduce((value, sum) => `${sum}<br />${value}`, "")
    : errors[key];
}

export function handleUserError(
  serverError: ServerError,
  setError: Dispatch<SetStateAction<string>>,
  setFields: (fields: any) => void,
  setSuccess = null,
) {
  const { error, details } = serverError;
  const fieldErrors = details?.fields;

  if (fieldErrors) {
    setError(error);

    if (fieldErrors.dataForType) {
      const dataForTypeErrors = fieldErrors.dataForType;

      for (const key of Object.keys(dataForTypeErrors)) {
        setFields((draft) => {
          draft[key].error = reduceErrorMessage(dataForTypeErrors, key);
        });
      }
      delete fieldErrors.dataForType;
    }

    for (const key of Object.keys(fieldErrors)) {
      const fieldKey = key.split(".").pop();
      setFields((draft) => {
        if (fieldKey) {
          draft[fieldKey].error = reduceErrorMessage(fieldErrors, key);
        }
      });
    }
  } else {
    setError(error);
  }

  if (setSuccess) {
    setSuccess(false);
  }
}

export function handleErrorFormWithSteps(
  serverError: ServerError,
  setError,
  setFields,
  keys,
  setActive,
) {
  const { error, details } = serverError;
  const fieldErrors = details?.fields;

  if (fieldErrors) {
    setError(error);

    let firstErrorIndex = keys.length - 1;

    if (fieldErrors.dataForType) {
      const dataForTypeErrors = fieldErrors.dataForType;

      for (const key of Object.keys(dataForTypeErrors)) {
        if (keys.indexOf(key) < firstErrorIndex) {
          firstErrorIndex = keys.indexOf(key);
        }
        setFields((draft) => {
          draft[key].error = reduceErrorMessage(dataForTypeErrors, key);
        });
      }
      delete fieldErrors.dataForType;
    }

    for (const key of Object.keys(fieldErrors)) {
      setFields((draft) => {
        draft[key].error = reduceErrorMessage(fieldErrors, key);
      });
      if (keys.indexOf(key) < firstErrorIndex) {
        firstErrorIndex = keys.indexOf(key);
      }
      delete fieldErrors[key];
    }
    setActive(keys[firstErrorIndex]);
  } else {
    setError(error);
  }
}
